// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DataSetup.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import Panel from 'share/components/controls/Izenda.Panel';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import RightPanelContent from './Izenda.RightPanelContent';
import Header from './Izenda.Header';

@connect()
export default class DataSetup extends Component {
  render() {
    const { model, localization } = this.props;
    const header = {
      component: Header,
      headerName: localization.getText('COMMON_LABEL_DATA_SETUP'),
      model: model
    };

    const titleClasses = 'grid-small-column u_borderRight u-bgWhite';

    return (
      <Panel
        className='u_fullHeight u_noMarginAll u_noPaddingAll u_noBorder'
        header={header}
        collapsible
        expanedOption={model.collapseAll}
      >
        <GridLayout>
          <GridLayout.Row className="u_noMarginAll u_borderTop">
            <GridLayout.Col cols="12" className="u_noPaddingAll u-bgGrayBlue">
                <GridLayout.Col cols="3" className={titleClasses}>
                  <div>
                    <span className="u_smallIcon u_alignMiddle">&#9899;</span>
                    <span>{localization.getText('CONTEXT_MENU_LABEL_CONNECTION_STRING')}</span>
                  </div>
              </GridLayout.Col>
              <RightPanelContent model={model} keysPath="dataSetup.dataConnectors.value" />
            </GridLayout.Col>
          </GridLayout.Row>

          <GridLayout.Row className="u_noMarginAll u_borderTop">
            <GridLayout.Col cols="12" className="u_noPaddingAll u-bgGrayBlue">
              <GridLayout.Col cols="3" className={titleClasses}>
                <div>
                  <span className="u_smallIcon u_alignMiddle">&#9899;</span>
                  <span>{localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_DATA_MODEL')}</span>
                </div>
              </GridLayout.Col>
              <RightPanelContent model={model} keysPath='dataSetup.dataModel.value' />
            </GridLayout.Col>
          </GridLayout.Row>

          <GridLayout.Row className='u_noMarginAll u_borderTop'>
            <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
              <GridLayout.Col cols='3' className={titleClasses}>
                <div>
                  <span className='u_smallIcon u_alignMiddle'>&#9899;</span>
                  <span>{localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_CUSTOM_VIEW')}</span>
                </div>
              </GridLayout.Col>
              <RightPanelContent isParent />
            </GridLayout.Col>
          </GridLayout.Row>

          <GridLayout.Row className='u_noMarginAll u_borderTop'>
            <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
              <GridLayout.Col cols='3' className={titleClasses}>
                <span className='izenda-Permission-FirstChild'>{localization.getText('COMMON_LABEL_CREATE')}</span>
              </GridLayout.Col>
              <RightPanelContent model={model} keysPath='dataSetup.dataModel.customView.create' />
            </GridLayout.Col>
          </GridLayout.Row>

          <GridLayout.Row className='u_noMarginAll u_borderTop'>
            <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
              <GridLayout.Col cols='3' className={titleClasses}>
                <span className='izenda-Permission-FirstChild'>{localization.getText('COMMON_LABEL_EDIT')}</span>
              </GridLayout.Col>
              <RightPanelContent model={model} keysPath='dataSetup.dataModel.customView.edit' />
            </GridLayout.Col>
          </GridLayout.Row>

          <GridLayout.Row className='u_noMarginAll u_borderTop'>
            <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
              <GridLayout.Col cols='3' className={titleClasses}>
                <span className='izenda-Permission-FirstChild'>{localization.getText('COMMON_LABEL_DELETE')}</span>
              </GridLayout.Col>
              <RightPanelContent model={model} keysPath='dataSetup.dataModel.customView.delete' />
            </GridLayout.Col>
          </GridLayout.Row>

          <GridLayout.Row className='u_noMarginAll u_borderTop'>
            <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
              <GridLayout.Col cols='3' className={titleClasses}>
                <div>
                  <span className='u_smallIcon u_alignMiddle'>&#9899;</span>
                  <span>{localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_ADVANCED_SETTING')}</span>
                </div>
              </GridLayout.Col>
              <RightPanelContent isParent />
            </GridLayout.Col>
          </GridLayout.Row>

          <GridLayout.Row className='u_noMarginAll u_borderTop'>
            <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
              <GridLayout.Col cols='3' className={titleClasses}>
                <span className='izenda-Permission-FirstChild'>
                  {localization.getText('ROLE_SETUP_PERMISSION_SUMMARY_LABEL_CATEGORIES')}
                </span>
              </GridLayout.Col>
              <RightPanelContent model={model} keysPath='dataSetup.advancedSettings.category' />
            </GridLayout.Col>
          </GridLayout.Row>

          <GridLayout.Row className='u_noMarginAll u_borderTop'>
            <GridLayout.Col cols='12' className='u_noPaddingAll u-bgGrayBlue'>
              <GridLayout.Col cols='3' className={titleClasses}>
                <span className='izenda-Permission-FirstChild'>{localization.getText('COMMON_LABEL_OTHERS')}</span>
              </GridLayout.Col>
              <RightPanelContent model={model} keysPath='dataSetup.advancedSettings.others' />
            </GridLayout.Col>
          </GridLayout.Row>

          <GridLayout.Row className="u_noMarginAll u_borderTop">
            <GridLayout.Col cols="12" className="u_noPaddingAll u-bgGrayBlue">
                <GridLayout.Col cols="3" className={titleClasses}>
                  <div>
                    <span className="u_smallIcon u_alignMiddle">&#9899;</span>
                    <span>{localization.getText('CONTEXT_MENU_LABEL_IMPORT')}</span>
                  </div>
              </GridLayout.Col>
              <RightPanelContent model={model} keysPath="dataSetup.import.value" />
            </GridLayout.Col>
          </GridLayout.Row>
        </GridLayout>
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/RoleSetup/RoleDetail/PermissionSummary/Izenda.DataSetup.js